import {Component} from 'react';
import h from 'react-hyperscript';
import './MainContent.scss';
import {eyebrow, footnote} from 'Components/Typography/Typography';
import LineGraph from 'Components/DataViz/LineGraph/LineGraph';
import Filters from '../Filters/Filters';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import {RESOURCE} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';

class MainContent extends Component {
  constructor(props) {
    super(props);
    this.inactiveClasses = 'tab__content';
    this.activeClasses = `${this.inactiveClasses} active`;
    this.largeViewportGraphSize = 950;
    this.state = {
      classes: this.inactiveClasses,
      bucket: null,
      isLoaded: false,
      filteredProducts: null,
      filteredData: null,
      graphContainerWidth: this.largeViewportGraphSize,
      prevWindow: null,
      currWindow: null,
    };
    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.handleViewAll = this.handleViewAll.bind(this);
    this.setRef = this.setRef.bind(this);
  }

  componentWillMount() {
    this.checkClasses();
    this.createFourCDetails();
  }

  setRef(ref) {
    this.graphRef = ref;

    this.setGraphContainerWidth();
  }

  setGraphContainerWidth() {
    const graphContainerWidth = this.graphRef.current.offsetWidth;

    if (
      this.state.graphContainerWidth !== graphContainerWidth &&
      this.props.dynamicGraphSize
    ) {
      this.setState({
        graphContainerWidth,
      });
    } else if (this.state.graphContainerWidth !== this.largeViewportGraphSize) {
      this.setState({
        graphContainerWidth: this.largeViewportGraphSize,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.screenWidth !== this.props.screenWidth && this.graphRef) {
      this.setGraphContainerWidth();
    }

    if (this.props.activeTab !== prevProps.activeTab) {
      this.checkClasses();
      this.createFourCDetails();
    }
  }

  checkClasses() {
    if (Number(this.props.activeTab) === this.props.i) {
      this.setClasses(this.activeClasses);
    } else {
      this.setClasses(this.inactiveClasses);
    }
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  createFourCDetails() {
    const bucket = [];
    this.props.totalProducts.forEach((product) => {
      if (this.props.fourCs.includes(product.id)) {
        bucket.push(product);
      }
    });
    this.setState(
        {
          bucket: bucket,
        },
        () => {
          this.setFilteredProducts(this.state.bucket);
        }
    );
  }

  findIdIndex(array, val) {
    const index = array.findIndex((item, i) => {
      return item.id === val;
    });
    return index;
  }

  handleFilterClick(e) {
    e.preventDefault();
    const targetFilter = e.currentTarget.getAttribute('datafilter');
    const index = this.findIdIndex(this.state.bucket, targetFilter);
    const target = this.state.bucket[index];

    let newArr = this.state.bucket.slice(0);
    if (this.state.filteredProducts) {
      newArr = this.state.filteredProducts.slice(0);
    }

    if (newArr.length === this.state.bucket.length) {
      newArr = [target];
    } else {
      if (newArr.includes(target)) {
        const i = this.findIdIndex(newArr, targetFilter);
        newArr.splice(i, 1);
      } else {
        newArr.push(target);
      }
    }

    if (newArr.length === 0 || newArr.length === this.state.bucket.length) {
      newArr = this.state.bucket;
    }

    this.setFilteredProducts(newArr);
  }

  handleViewAll(e) {
    e.preventDefault();
    this.setFilteredProducts(this.state.bucket);
  }

  setFilteredProducts(values) {
    this.setState(
        {
          filteredProducts: values,
        },
        () => {
          const filteredData = this.getFilteredData();
          this.setFilteredData(filteredData);
        }
    );
  }

  setFilteredData(value) {
    this.setState(
        {
          filteredData: value,
        },
        () => {
          this.setState({
            isLoaded: true,
          });
        }
    );
  }

  getFilteredData() {
    const productData = [];
    this.props.weeklyDataByProduct.forEach((item) => {
      let bucketData;
      this.state.bucket.forEach((bucketProd) => {
        if (bucketProd.id === item.product) {
          bucketData = item;
        }
      });
      if (bucketData) {
        productData.push(bucketData);
      }
    });
    return productData;
  }

  render() {
    if (this.state.isLoaded) {
      return h(
          'div',
          {
            id: `content-item__${this.props.i}`,
            key: `content-item-${this.props.i}`,
            className: this.state.classes,
          },
          [
            h(
                TooltipGroup,
                {
                  title: this.props.item.tooltip,
                  className: 'padding-top--micro-2',
                },
                h(
                    eyebrow,
                    {
                      key: `content-item-${this.props.i}-eyebrow`,
                      className: 'main-content__title',
                    },
                    `${this.props.item.title} Usage`
                ),
            ),
            h(
                footnote,
                {
                  key: `content-item-date-${this.props.i}-eyebrow`,
                  className: 'footnote--date chromebooks-devices__aue ' +
                  'text--grey text--small',
                },
                this.props.currWindow,
            ),

            h(
                'div',
                {
                  key: 'four-c__line-graph__key',
                  className: 'graph--container',
                },
                h(
                    LineGraph,
                    {
                      id: `four-c__line-graph--${this.props.id}`,
                      activeProducts: this.state.filteredProducts,
                      filteredData: this.state.filteredData,
                      barWidth: 10,
                      color: '#1a73e8',
                      size: [this.state.graphContainerWidth, 264],
                      setRef: this.setRef,
                    },
                    null
                )
            ),

            h(
                Filters,
                {
                  title: 'Filter:',
                  totalFilters: this.state.bucket,
                  handleFilterClick: this.handleFilterClick,
                  handleViewAll: this.handleViewAll,
                  filteredProducts: this.state.filteredProducts,
                },
                null
            ),

            h('div', {id: `four-c__resources--${this.props.id}`}, [
              h(
                  eyebrow,
                  {
                    className: 'padding-bottom--sm padding-top--lg-2',
                  },
                  `Resources for ${this.props.item.title}`
              ),
              h(
                  'div',
                  {
                    className: `flex flex--wrap-sm padding-bottom--md
                  flex--space-between flex--align-start`,
                  },
                  this.props.item.resources.map((item, i) => {
                    const href = item.href;

                    return h(
                        'a',
                        {
                          key: `content-item-${i}-content`,
                          className: `cta text--blue text--small-2
                      padding-right--xl col-ratio-1--sm`,
                          href,
                          target: '_blank',
                          onClick: () => {
                            pushGTMEvent(RESOURCE.TAG, {
                              event: RESOURCE.EVENT,
                              action: {
                                resource_action: RESOURCE.ACTION.RESOURCE_CLICK,
                              },
                              variables: {
                                resource_category: 'FourCs',
                                resource_url: href,
                              },
                            });
                          },
                        },
                        item.title
                    );
                  })
              ),
            ]),
          ]
      );
    } else {
      return null;
    }
  }
}

export default MainContent;
